import { render, staticRenderFns } from "./lostBadges.vue?vue&type=template&id=20cacd84&"
import script from "./lostBadges.vue?vue&type=script&lang=js&"
export * from "./lostBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports